import { BooleanValue } from 'common/genericOptions';
import { 
  GarantiaTipoEnum, 
  GarantiaSubTipoEnum, 
  IndexadorRemuneracao,
  ConvencaoJurosFixo,
  TipoProRata,
  PeriodicidadeCorrecao,
  DefasagemFixingDiario,
  InstrumentoFinanceiro,
} from '../common/genericTypes';
import store from '../store';

/* Nota Comercial */
import { updateField as updateCaracteristicasNCField } from '../store/modules/notaComercial/caracteristicas';
import { updateField as updateCriteriosNCField, updateRemuneracaoField as updateRemuneracaoNCField, updateCustoEmissaoField as updateCustoEmissaoNCField } from '../store/modules/notaComercial/criteriosRemuneracao';
import { updateField as updateEventosNCField, updateAmortizacoes as updateAmortizacoesNC, updateDatasPagamentoJuros as updateDatasPagamentoJurosNC, updateDatasIncorporacaoJuros as updateDatasIncorporacaoJurosNC } from '../store/modules/notaComercial/eventos';
import { updateId as updateEmissorIdNC } from '../store/modules/notaComercial/emissor';

/* Certificado Recebíveis */
import { updateField as updateCaracteristicasCRField } from '../store/modules/certificadoRecebiveis/caracteristicas';
import { updateField as updateCriteriosCRField, updateRemuneracaoField as updateRemuneracaoCRField, updateCustoEmissaoField as updateCustoEmissaoCRField } from '../store/modules/certificadoRecebiveis/criteriosRemuneracao';
import { updateField as updateEventosCRField, updateAmortizacoes as updateAmortizacoesCR, updateDatasPagamentoJuros as updateDatasPagamentoJurosCR, updateDatasIncorporacaoJuros as updateDatasIncorporacaoJurosCR } from '../store/modules/certificadoRecebiveis/eventos';
import { updateId as updateEmissorIdCR } from '../store/modules/certificadoRecebiveis/emissor';

/* CDCA */
import { updateField as updateCaracteristicasCDCAField } from '../store/modules/cdca/caracteristicas';
import { updateField as updateCriteriosCDCAField, updateRemuneracaoField as updateRemuneracaoCDCAField, updateCustoEmissaoField as updateCustoEmissaoCDCAField } from '../store/modules/cdca/criteriosRemuneracao';
import { updateField as updateEventosCDCAField, updateAmortizacoes as updateAmortizacoesCDCA, updateDatasPagamentoJuros as updateDatasPagamentoJurosCDCA, updateDatasIncorporacaoJuros as updateDatasIncorporacaoJurosCDCA } from '../store/modules/cdca/eventos';
import { updateId as updateEmissorIdCDCA } from '../store/modules/cdca/emissor';

/* CRA */
import { updateField as updateCaracteristicasCRAField } from '../store/modules/cra/caracteristicas';
import { updateField as updateCriteriosCRAField, updateRemuneracaoField as updateRemuneracaoCRAField, updateCustoEmissaoField as updateCustoEmissaoCRAField } from '../store/modules/cra/criteriosRemuneracao';
import { updateField as updateEventosCRAField, updateAmortizacoes as updateAmortizacoesCRA, updateDatasPagamentoJuros as updateDatasPagamentoJurosCRA, updateDatasIncorporacaoJuros as updateDatasIncorporacaoJurosCRA } from '../store/modules/cra/eventos';
import { updateId as updateEmissorIdCRA } from '../store/modules/cra/emissor';

/* CRI */
import { updateField as updateCaracteristicasCRIField } from '../store/modules/cri/caracteristicas';
import { updateField as updateCriteriosCRIField, updateRemuneracaoField as updateRemuneracaoCRIField, updateCustoEmissaoField as updateCustoEmissaoCRIField } from '../store/modules/cri/criteriosRemuneracao';
import { updateField as updateEventosCRIField, updateAmortizacoes as updateAmortizacoesCRI, updateDatasPagamentoJuros as updateDatasPagamentoJurosCRI, updateDatasIncorporacaoJuros as updateDatasIncorporacaoJurosCRI } from '../store/modules/cri/eventos';
import { updateId as updateEmissorIdCRI } from '../store/modules/cri/emissor';

/* Debenture */
import { updateField as updateCaracteristicasDebentureField } from '../store/modules/debenture/caracteristicas';
import { updateField as updateCriteriosDebentureField, updateRemuneracaoField as updateRemuneracaoDebentureField, updateCustoEmissaoField as updateCustoEmissaoDebentureField } from '../store/modules/debenture/criteriosRemuneracao';
import { updateField as updateEventosDebentureField, updateAmortizacoes as updateAmortizacoesDebenture, updateDatasPagamentoJuros as updateDatasPagamentoJurosDebenture, updateDatasIncorporacaoJuros as updateDatasIncorporacaoJurosDebenture } from '../store/modules/debenture/eventos';
import { updateId as updateEmissorIdDebenture } from '../store/modules/debenture/emissor';


import { addAlert } from '../store/modules/snackBar';

const createCaseInsensitiveMapping = <T>(baseMapping: Record<string, T>): Record<string, T> => {
  const result: Record<string, T> = {};
  
  Object.entries(baseMapping).forEach(([key, value]) => {
    result[key] = value;
    result[key.toLowerCase()] = value;
    result[key.toUpperCase()] = value;
    result[key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()] = value;
  });
  
  return result;
};

const mapIndexadorRemuneracao = (apiValue: string): IndexadorRemuneracao | undefined => {
  const baseMapping: Record<string, IndexadorRemuneracao> = {
    'PREFIXADO': IndexadorRemuneracao.Prefixado,
    'CDI': IndexadorRemuneracao.CDI,
    'SELIC': IndexadorRemuneracao.Selic,
    'IGPM': IndexadorRemuneracao.IGPM,
    'IPCA': IndexadorRemuneracao.IPCA,
    'TR': IndexadorRemuneracao.TR,
  };
  
  const mapping = createCaseInsensitiveMapping(baseMapping);
  
  const result = mapping[apiValue];

  return result;
};

const mapConvencaoJurosFixo = (apiValue: string): ConvencaoJurosFixo | undefined => {
  const baseMapping: Record<string, ConvencaoJurosFixo> = {
    'Actual30_360': ConvencaoJurosFixo.Actual30_360,
    'Actual360': ConvencaoJurosFixo.Actual360,
    'Actual365': ConvencaoJurosFixo.Actual365,
    'Business252': ConvencaoJurosFixo.Business252,
    'Month_30': ConvencaoJurosFixo.Month_30,
    '_30dc': ConvencaoJurosFixo._30dc,
    'DCP_360': ConvencaoJurosFixo.DCP_360,
    'DCP_365': ConvencaoJurosFixo.DCP_365,
    'DUP_252': ConvencaoJurosFixo.DUP_252,
    '30/360': ConvencaoJurosFixo.Actual30_360,
    'DC/360': ConvencaoJurosFixo.Actual360,
    'DC/365': ConvencaoJurosFixo.Actual365,
    'DU/252': ConvencaoJurosFixo.Business252,
    'DC/30': ConvencaoJurosFixo.Month_30,
    '30dc': ConvencaoJurosFixo._30dc,
    '30/360_aa': ConvencaoJurosFixo.Actual30_360,
    'DC/360_aa': ConvencaoJurosFixo.Actual360,
    'DC/365_aa': ConvencaoJurosFixo.Actual365,
    'DU/252_aa': ConvencaoJurosFixo.Business252,
    'DC/30_am': ConvencaoJurosFixo.Month_30,
    '30dc_am': ConvencaoJurosFixo._30dc,
  };
  
  const mapping = createCaseInsensitiveMapping(baseMapping);
  
  const result = mapping[apiValue];
  
  return result;
};

const mapTipoProRata = (apiValue: string): TipoProRata | undefined => {
  const baseMapping: Record<string, TipoProRata> = {
    'CORRIDO': TipoProRata.Corrido,
    'UTIL': TipoProRata.Util,
  };
  
  const mapping = createCaseInsensitiveMapping(baseMapping);
  
  const result = mapping[apiValue];
  
  return result;
};

const mapDefasagemFixingDiario = (apiValue: string | number): DefasagemFixingDiario | undefined => {
  const mapping: Record<string, DefasagemFixingDiario> = {
    'D-1': DefasagemFixingDiario.Dmenos1,
    'D-2': DefasagemFixingDiario.Dmenos2,
    'D-3': DefasagemFixingDiario.Dmenos3,
    '1': DefasagemFixingDiario.Dmenos1,
    '2': DefasagemFixingDiario.Dmenos2,
    '3': DefasagemFixingDiario.Dmenos3,
  };
  return mapping[String(apiValue)];
};

const mapPeriodicidadeCorrecao = (apiValue: string): PeriodicidadeCorrecao | undefined => {
  const mapping: Record<string, PeriodicidadeCorrecao> = {
    'MENSAL': PeriodicidadeCorrecao.Mensal,
    'ANUAL': PeriodicidadeCorrecao.Anual,
    'DIARIO': PeriodicidadeCorrecao.Diario,
  };
  return mapping[apiValue];
};

export interface DesminutadorResponse {
  tipo?: string;
  numeroDaEmissao: number;
  serieUnica: boolean;
  nroDeSeries: number;
  qtdeDaEmissao: number;
  valorNominalUnitario: number;
  volumeDaEmissao: number;
  moedaDaEmissao: string;
  dataDaEmissao: string;
  dataDeVencimento: string;
  temDeposito: boolean;
  cnpjEscriturador: string;
  tipoDeOferta: string;
  emissorCnpj: string;
  amortizacoes: Array<{
    id: string;
    percentualAmortizacao: number;
    dataAmortizacao: string;
    isNew: boolean;
  }>;
  pagamentosDeJuros: Array<any>;
  distribuicao: Array<any>;
  depositariaDaEmissao: string;
  bancoLiquidanteEmissor: {
    razaoSocial: string;
    codigo: string;
    agencia: string;
    conta: string;
    cnpj?: string;
  };
  negociacaoSecundaria?: string;
  regimeFiduciario?: boolean;
  cartulaFormalizado?: boolean;
  isin?: string;
  statusEmissao?: string;
  coobrigacao?: boolean;
  localDeEmissao: {
    local: string;
    uf: string;
    localDoPagamento: string;
    ufDoPagamento: string;
  };
  garantias: Array<{
    tipo: string;
    subtipo: string;
    descricaoAdicional: string;
  }>;
  criteriosDeRemuneracao: {
    indexador: string;
    taxaDeJuros: number;
    dataPrimeiroPagtoDeJuros: string;
    dataPrimeiroPagtoDaAmortizacao: string;
    resgateAntecipado: boolean;
    frequenciaDeJuros: string;
    frequenciaDaAmortizacao: string;
    configuracaoIndexador: {
      percentualDoIndexador: number;
      defasagem: number;
      convencao: string;
      periodicidadeCorrecao: string;
      proRata: string;
      diaAniversario: string;
      mesAniversario: string;
      tipoProjecao: string;
    };
  };
  rentabilidade: {
    inicioDaRentabilidade: string;
    incorporacaoDeJuros: Array<any>;
  };
}

/**
 * Função para mapear os dados da resposta da API para o estado do formulário de características
 */
export const mapToCaracteristicasState = (data: DesminutadorResponse, participantes: any[] = [], bancos: any[] = [], dispatch: any, instrumentoTipo: InstrumentoFinanceiro) => {
  const actions = getInstrumentActions(instrumentoTipo);
  const state = store.getState();

  const { options, unidadesFederativas, depositariaEmissoes, series, negociacoesSecundarias, tiposLiquidacao, naturezaPessoa } = state.notaComercialCadastro.metadata;
  
  let caracteristicasState: any = {
    cnpjEmissor: '',
    cnpjEscriturador: '',
    numeroEmissao: '0',
    numeroSerie: '1',
    tipoSerie: series[0],
    distribuicaoPublica: options[1],
    depositariaEmissao: depositariaEmissoes[0],
    localEmissao: '',
    ufLocalEmissao: unidadesFederativas[0],
    localPagamento: '',
    ufLocalPagamento: unidadesFederativas[0],
    utilizacaoAnuncioInicioDistribuicao: options[1],
    tipoDistribuicaoPublica: options[1],
    contraparteRecebedora: options[1],
    bancoLiquidanteEmissor: '',
    cnpjBancoLiquidanteEmissor: '',
    codigoBancoContaCorrenteVinculadaEmissao: '',
    numeroAgenciaContaCorrenteVinculadaEmissao: '',
    numeroContaCorrenteVinculadaEmissao: '',
    tipoLiquidacao: tiposLiquidacao[0],
    negociacaoSecundariaPor: negociacoesSecundarias[0],
    garantias: [],
    regimeFiduciario: options[1],
    cartulaFormalizado: options[0],
    isin: '',
    statusEmissao: '',
    coobrigacao: options[0],
    razaoSocialAgenteFiduciario: '',
    cpfCnpjAgenteFiduciario: '',
    naturezaAgenteFiduciario: naturezaPessoa[0],
    coordenadoresIds: [],
    coordenadorLiderId: ''
  };
  
  const emissorEncontrado = participantes.find((p: any) => 
    p.cnpj === data.emissorCnpj && 
    p.funcoes?.some((f: any) => f.funcao === 'EMISSOR')
  );

  if (emissorEncontrado) {
    dispatch(actions.updateEmissorId(emissorEncontrado.id));
    caracteristicasState.cnpjEmissor = emissorEncontrado.cnpj;
  } else {
    caracteristicasState.cnpjEmissor = data.emissorCnpj;
  }
  
  const escrituradorEncontrado = participantes.find((p: any) => 
    p.cnpj === data.cnpjEscriturador && 
    p.funcoes?.some((f: any) => f.funcao === 'ESCRITURADOR')
  );

  if (escrituradorEncontrado) {
    caracteristicasState.cnpjEscriturador = escrituradorEncontrado.cnpj;
    caracteristicasState.razaoSocialEscriturador = escrituradorEncontrado.razaoSocial;
  } else {
    caracteristicasState.cnpjEscriturador = data.cnpjEscriturador;
    caracteristicasState.razaoSocialEscriturador = '';
  }
  
  if (data.numeroDaEmissao !== undefined) {
    caracteristicasState.numeroEmissao = data.numeroDaEmissao.toString();
  }
  
  if (data.nroDeSeries !== undefined) {
    caracteristicasState.numeroSerie = data.nroDeSeries.toString();
  }
  
  if (data.serieUnica !== undefined) {
    const tipoSerieOption = series.find((s: any) => 
      (data.serieUnica === true && s.description === 'Série Única') || 
      (data.serieUnica === false && s.description === 'Múltiplas Séries')
    );
    if (tipoSerieOption) {
      caracteristicasState.tipoSerie = tipoSerieOption;
    }
  }
  
  if (data.tipoDeOferta) {
    const distribuicaoOption = options.find((o: any) => 
      (data.tipoDeOferta === 'PUBLICA' && o.value === BooleanValue.Yes) || 
      (data.tipoDeOferta !== 'PUBLICA' && o.value === BooleanValue.No)
    );
    if (distribuicaoOption) {
      caracteristicasState.distribuicaoPublica = distribuicaoOption;
    }
  }
  
  if (data.depositariaDaEmissao) {
    const depositariaOption = depositariaEmissoes.find((d: any) => 
      d.description.includes(data.depositariaDaEmissao)
    );
    if (depositariaOption) {
      caracteristicasState.depositariaEmissao = depositariaOption;
    }
  }
  
  if (data.localDeEmissao) {
    if (data.localDeEmissao.local) {
      caracteristicasState.localEmissao = data.localDeEmissao.local;
    }
    
    if (data.localDeEmissao.uf) {
      const ufOption = unidadesFederativas.find((uf: any) => uf.value === data.localDeEmissao.uf);
      if (ufOption) {
        caracteristicasState.ufLocalEmissao = ufOption;
      }
    }
    
    if (data.localDeEmissao.localDoPagamento) {
      caracteristicasState.localPagamento = data.localDeEmissao.localDoPagamento;
    }
    
    if (data.localDeEmissao.ufDoPagamento) {
      const ufPagamentoOption = unidadesFederativas.find((uf: any) => uf.value === data.localDeEmissao.ufDoPagamento);
      if (ufPagamentoOption) {
        caracteristicasState.ufLocalPagamento = ufPagamentoOption;
      }
    }
  }
  
  if (data.bancoLiquidanteEmissor) {
    
    const bancoEncontrado = bancos.find((b: any) => 
      b.code === data.bancoLiquidanteEmissor.codigo
    );
    
    if (bancoEncontrado) {
      caracteristicasState.bancoLiquidanteEmissor = bancoEncontrado.fullname;
      caracteristicasState.cnpjBancoLiquidanteEmissor = bancoEncontrado.cnpj;
      caracteristicasState.codigoBancoContaCorrenteVinculadaEmissao = bancoEncontrado.code;
    } else {
      if (data.bancoLiquidanteEmissor.razaoSocial) {
        caracteristicasState.bancoLiquidanteEmissor = data.bancoLiquidanteEmissor.razaoSocial;
      }
      if (data.bancoLiquidanteEmissor.cnpj) {
        caracteristicasState.cnpjBancoLiquidanteEmissor = data.bancoLiquidanteEmissor.cnpj;
      }
      if (data.bancoLiquidanteEmissor.codigo) {
        caracteristicasState.codigoBancoContaCorrenteVinculadaEmissao = data.bancoLiquidanteEmissor.codigo;
      }
    }
    
    if (data.bancoLiquidanteEmissor.agencia) {
      caracteristicasState.numeroAgenciaContaCorrenteVinculadaEmissao = data.bancoLiquidanteEmissor.agencia;
    }
    
    if (data.bancoLiquidanteEmissor.conta) {
      caracteristicasState.numeroContaCorrenteVinculadaEmissao = data.bancoLiquidanteEmissor.conta;
    }
  }
  
  if (Array.isArray(data.garantias) && data.garantias.length > 0) {
    caracteristicasState.garantias = data.garantias.map((garantia: any) => {
      let tipoEnum = GarantiaTipoEnum.SEM_GARANTIA;
      let subtipoEnum = GarantiaSubTipoEnum.SEM_COOBRIGACAO;
      
      if (garantia.tipo) {
        switch (garantia.tipo) {
          case 'QUIROGRAFICA':
            tipoEnum = GarantiaTipoEnum.SEM_GARANTIA;
            subtipoEnum = garantia.subtipo === 'SEM_GARANTIA_SEM_COOBRIGACAO' 
              ? GarantiaSubTipoEnum.SEM_COOBRIGACAO 
              : GarantiaSubTipoEnum.COM_COOBRIGACAO;
            break;
          case 'FIDEJUSSORIA':
            tipoEnum = GarantiaTipoEnum.FIDEJUSSORIA;
            subtipoEnum = GarantiaSubTipoEnum.AVAL;
            break;
          case 'REAL':
            tipoEnum = GarantiaTipoEnum.GARANTIA_REAL;
            subtipoEnum = GarantiaSubTipoEnum.DIREITOS_CREDITORIOS;
            break;
        }
      }
      
      return {
        id: tipoEnum,
        subTipos: [{ id: subtipoEnum }],
        descricaoAdicional: garantia.descricaoAdicional || ''
      };
    });
  }
  
  if (data.regimeFiduciario !== undefined) {
    caracteristicasState.regimeFiduciario = options.find((o: any) => 
      o.value === (data.regimeFiduciario ? BooleanValue.Yes : BooleanValue.No)
    ) || options[1];
  }
  
  if (data.cartulaFormalizado !== undefined) {
    caracteristicasState.cartulaFormalizado = options.find((o: any) => 
      o.value === (data.cartulaFormalizado ? BooleanValue.Yes : BooleanValue.No)
    ) || options[0];
  }
  
  if (data.isin) {
    caracteristicasState.isin = data.isin;
  }
  
  if (data.statusEmissao) {
    caracteristicasState.statusEmissao = data.statusEmissao;
  }
  
  if (data.coobrigacao !== undefined) {
    caracteristicasState.coobrigacao = options.find((o: any) => 
      o.value === (data.coobrigacao ? BooleanValue.Yes : BooleanValue.No)
    ) || options[0];
  }
  
  if (data.negociacaoSecundaria) {
    const negociacaoOption = negociacoesSecundarias.find((n: any) => n.value === data.negociacaoSecundaria);
    if (negociacaoOption) {
      caracteristicasState.negociacaoSecundariaPor = negociacaoOption;
    }
  }
  
  return caracteristicasState;
};

export const mapToCriteriosRemuneracaoState = (data: DesminutadorResponse) => {
  const parseDate = (dateString: string) => {
    if (!dateString) return null;
    return new Date(dateString);
  };

  const state = store.getState();
  const metadata = state.notaComercialCadastro.metadata;
  
  let criteriosRemuneracaoState: any = {
    valorNominalUnitarioEmissao: 0,
    quantidadeEmitida: 0,
    volumeEmissao: 0,
    moedaEmissao: 'BRL',
    dataEmissao: null,
    dataVencimento: null,
    inicioRentabilidade: '',
    dataInicioRentabilidade: null,
    custodiantes: [],
    custoEmissao: {
      feeLaqusBruto: 0,
      feeLaqusLiquido: 0,
      feeRepasse: 0,
      custoTotal: 0
    },
    remuneracao: {
      indexador: '',
      taxaJuros: 0,
      percentualDoIndexador: 0,
      defasagem: 0,
      convencao: '',
      proRata: '',
      resgateAntecipado: false,
      periodicidadeJuros: '',
      periodicidadeAmortizacao: '',
      primeiraParcelaJuros: null,
      primeiraParcelaAmortizacao: null
    },
    tipoPagamento: '',
    convencaoCalendarioPagamento: '',
    periodicidadeAmortizacao: '',
    primeiraParcelaAmortizacao: null,
    periodicidadeJuros: '',
    primeiraParcelaJuros: null
  };
  
  if (data.valorNominalUnitario !== undefined) {
    criteriosRemuneracaoState.valorNominalUnitarioEmissao = data.valorNominalUnitario;
  }
  
  if (data.qtdeDaEmissao !== undefined) {
    criteriosRemuneracaoState.quantidadeEmitida = data.qtdeDaEmissao;
  }
  
  if (data.volumeDaEmissao !== undefined) {
    criteriosRemuneracaoState.volumeEmissao = data.volumeDaEmissao;
  }
  
  if (data.moedaDaEmissao) {
    criteriosRemuneracaoState.moedaEmissao = data.moedaDaEmissao;
  }
  
  if (data.dataDaEmissao) {
    criteriosRemuneracaoState.dataEmissao = parseDate(data.dataDaEmissao);
  }
  
  if (data.dataDeVencimento) {
    criteriosRemuneracaoState.dataVencimento = parseDate(data.dataDeVencimento);
  }
  
  if (data.rentabilidade) {
    if (data.rentabilidade.inicioDaRentabilidade) {
      criteriosRemuneracaoState.inicioRentabilidade = data.rentabilidade.inicioDaRentabilidade;
      
      if (data.rentabilidade.inicioDaRentabilidade === 'DATA_DE_EMISSAO' && data.dataDaEmissao) {
        criteriosRemuneracaoState.dataInicioRentabilidade = parseDate(data.dataDaEmissao);
      } else if (data.rentabilidade.inicioDaRentabilidade === 'DATA_DE_INTEGRALIZACAO' && data.dataDaEmissao) {
        criteriosRemuneracaoState.dataInicioRentabilidade = parseDate(data.dataDaEmissao);
      }
    }
  }
  
  if (data.criteriosDeRemuneracao) {
    if (data.criteriosDeRemuneracao.indexador) {
      const indexadorEnum = mapIndexadorRemuneracao(data.criteriosDeRemuneracao.indexador);
      if (indexadorEnum) {
        criteriosRemuneracaoState.remuneracao.indexador = indexadorEnum;
      }
    }
    
    if (data.criteriosDeRemuneracao.taxaDeJuros !== undefined) {
      criteriosRemuneracaoState.remuneracao.taxaJurosFixoSpreadPorcentagem = data.criteriosDeRemuneracao.taxaDeJuros;
    }
    
    if (data.criteriosDeRemuneracao.resgateAntecipado !== undefined) {
      criteriosRemuneracaoState.remuneracao.resgateAntecipado = data.criteriosDeRemuneracao.resgateAntecipado;
    }
    
    if (data.criteriosDeRemuneracao.dataPrimeiroPagtoDeJuros) {
      criteriosRemuneracaoState.remuneracao.primeiraParcelaJuros = parseDate(data.criteriosDeRemuneracao.dataPrimeiroPagtoDeJuros);
    }
    
    if (data.criteriosDeRemuneracao.dataPrimeiroPagtoDaAmortizacao) {
      criteriosRemuneracaoState.remuneracao.primeiraParcelaAmortizacao = parseDate(data.criteriosDeRemuneracao.dataPrimeiroPagtoDaAmortizacao);
    }
    
    if (data.criteriosDeRemuneracao.frequenciaDeJuros) {
      criteriosRemuneracaoState.remuneracao.periodicidadeJuros = data.criteriosDeRemuneracao.frequenciaDeJuros;
    }
    
    if (data.criteriosDeRemuneracao.frequenciaDaAmortizacao) {
      criteriosRemuneracaoState.remuneracao.periodicidadeAmortizacao = data.criteriosDeRemuneracao.frequenciaDaAmortizacao;
    }
    
    if (data.criteriosDeRemuneracao.configuracaoIndexador) {
      const configuracao = data.criteriosDeRemuneracao.configuracaoIndexador;
      
      if (configuracao.percentualDoIndexador !== undefined) {
        criteriosRemuneracaoState.remuneracao.indexadorPorcentagem = configuracao.percentualDoIndexador;
      }
      
      if (configuracao.defasagem !== undefined) {
        const defasagemEnum = mapDefasagemFixingDiario(configuracao.defasagem);
        if (defasagemEnum) {
          criteriosRemuneracaoState.remuneracao.defasagemFixing = defasagemEnum;
        }
      }
      
      if (configuracao.convencao) {
        const convencaoEnum = mapConvencaoJurosFixo(configuracao.convencao);
        if (convencaoEnum) {
          criteriosRemuneracaoState.remuneracao.convencao = convencaoEnum;
        }
      }
      
      if (configuracao.proRata) {
        const proRataEnum = mapTipoProRata(configuracao.proRata);
        if (proRataEnum) {
          criteriosRemuneracaoState.remuneracao.proRata = proRataEnum;
        }
      }
      
      if (configuracao.periodicidadeCorrecao) {
        const periodicidadeEnum = mapPeriodicidadeCorrecao(configuracao.periodicidadeCorrecao);
        if (periodicidadeEnum) {
          criteriosRemuneracaoState.remuneracao.periodicidadeCorrecao = periodicidadeEnum;
        }
      }
      
      if (configuracao.diaAniversario) {
        criteriosRemuneracaoState.remuneracao.diaAniversario = configuracao.diaAniversario;
      }
      
      if (configuracao.mesAniversario) {
        criteriosRemuneracaoState.remuneracao.mesAniversario = configuracao.mesAniversario;
      }
      
      if (configuracao.tipoProjecao) {
        criteriosRemuneracaoState.remuneracao.tipoProjecao = configuracao.tipoProjecao;
      }
    }
    
    if (data.criteriosDeRemuneracao.indexador) {
      criteriosRemuneracaoState.remuneracao.indexador = data.criteriosDeRemuneracao.indexador;
    }
  }
  
  return criteriosRemuneracaoState;
};

export const mapToEventosFinanceirosState = (data: DesminutadorResponse) => {
  const parseDate = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  let eventosFinanceirosState: any = {
    amortizacoes: [],
    datasPagamentoJuros: [],
    datasIncorporacaoJuros: []
  };
  
  if (Array.isArray(data.amortizacoes) && data.amortizacoes.length > 0) {
    eventosFinanceirosState.amortizacoes = data.amortizacoes.map((amortizacao: any) => ({
      id: `amort_${Date.now()}_${Math.random()}`,
      percentualAmortizacao: amortizacao.percentualAmortizacao || 0,
      dataAmortizacao: parseDate(amortizacao.dataAmortizacao)
    }));
  }
  
  if (Array.isArray(data.pagamentosDeJuros) && data.pagamentosDeJuros.length > 0) {
    eventosFinanceirosState.datasPagamentoJuros = data.pagamentosDeJuros.map((pagamento: any) => ({
      id: `juros_${Date.now()}_${Math.random()}`,
      date: parseDate(pagamento.data)
    }));
  }
  
  if (data.rentabilidade && Array.isArray(data.rentabilidade.incorporacaoDeJuros) && data.rentabilidade.incorporacaoDeJuros.length > 0) {
    eventosFinanceirosState.datasIncorporacaoJuros = data.rentabilidade.incorporacaoDeJuros.map((incorporacao: any) => ({
      id: `incorp_${Date.now()}_${Math.random()}`,
      date: parseDate(incorporacao.data)
    }));
  }
  
  return eventosFinanceirosState;
};

const getInstrumentActions = (instrumentoTipo: InstrumentoFinanceiro) => {
  switch (instrumentoTipo) {
    case InstrumentoFinanceiro.NotaComercial:
      return {
        updateCaracteristicasField: updateCaracteristicasNCField,
        updateCriteriosField: updateCriteriosNCField,
        updateRemuneracaoField: updateRemuneracaoNCField,
        updateCustoEmissaoField: updateCustoEmissaoNCField,
        updateEventosField: updateEventosNCField,
        updateAmortizacoes: updateAmortizacoesNC,
        updateDatasPagamentoJuros: updateDatasPagamentoJurosNC,
        updateDatasIncorporacaoJuros: updateDatasIncorporacaoJurosNC,
        updateEmissorId: updateEmissorIdNC
      };
    case InstrumentoFinanceiro.CertificadoRecebiveis:
      return {
        updateCaracteristicasField: updateCaracteristicasCRField,
        updateCriteriosField: updateCriteriosCRField,
        updateRemuneracaoField: updateRemuneracaoCRField,
        updateCustoEmissaoField: updateCustoEmissaoCRField,
        updateEventosField: updateEventosCRField,
        updateAmortizacoes: updateAmortizacoesCR,
        updateDatasPagamentoJuros: updateDatasPagamentoJurosCR,
        updateDatasIncorporacaoJuros: updateDatasIncorporacaoJurosCR,
        updateEmissorId: updateEmissorIdCR
      };
    case InstrumentoFinanceiro.Cdca:
      return {
        updateCaracteristicasField: updateCaracteristicasCDCAField,
        updateCriteriosField: updateCriteriosCDCAField,
        updateRemuneracaoField: updateRemuneracaoCDCAField,
        updateCustoEmissaoField: updateCustoEmissaoCDCAField,
        updateEventosField: updateEventosCDCAField,
        updateAmortizacoes: updateAmortizacoesCDCA,
        updateDatasPagamentoJuros: updateDatasPagamentoJurosCDCA,
        updateDatasIncorporacaoJuros: updateDatasIncorporacaoJurosCDCA,
        updateEmissorId: updateEmissorIdCDCA
      };
    case InstrumentoFinanceiro.Cra:
      return {
        updateCaracteristicasField: updateCaracteristicasCRAField,
        updateCriteriosField: updateCriteriosCRAField,
        updateRemuneracaoField: updateRemuneracaoCRAField,
        updateCustoEmissaoField: updateCustoEmissaoCRAField,
        updateEventosField: updateEventosCRAField,
        updateAmortizacoes: updateAmortizacoesCRA,
        updateDatasPagamentoJuros: updateDatasPagamentoJurosCRA,
        updateDatasIncorporacaoJuros: updateDatasIncorporacaoJurosCRA,
        updateEmissorId: updateEmissorIdCRA
      };
    case InstrumentoFinanceiro.Cri:
      return {
        updateCaracteristicasField: updateCaracteristicasCRIField,
        updateCriteriosField: updateCriteriosCRIField,
        updateRemuneracaoField: updateRemuneracaoCRIField,
        updateCustoEmissaoField: updateCustoEmissaoCRIField,
        updateEventosField: updateEventosCRIField,
        updateAmortizacoes: updateAmortizacoesCRI,
        updateDatasPagamentoJuros: updateDatasPagamentoJurosCRI,
        updateDatasIncorporacaoJuros: updateDatasIncorporacaoJurosCRI,
        updateEmissorId: updateEmissorIdCRI
      };
    case InstrumentoFinanceiro.Debenture:
      return {
        updateCaracteristicasField: updateCaracteristicasDebentureField,
        updateCriteriosField: updateCriteriosDebentureField,
        updateRemuneracaoField: updateRemuneracaoDebentureField,
        updateCustoEmissaoField: updateCustoEmissaoDebentureField,
        updateEventosField: updateEventosDebentureField,
        updateAmortizacoes: updateAmortizacoesDebenture,
        updateDatasPagamentoJuros: updateDatasPagamentoJurosDebenture,
        updateDatasIncorporacaoJuros: updateDatasIncorporacaoJurosDebenture,
        updateEmissorId: updateEmissorIdDebenture
      };
    default:
      return {
        updateCaracteristicasField: updateCaracteristicasNCField,
        updateCriteriosField: updateCriteriosNCField,
        updateRemuneracaoField: updateRemuneracaoNCField,
        updateCustoEmissaoField: updateCustoEmissaoNCField,
        updateEventosField: updateEventosNCField,
        updateAmortizacoes: updateAmortizacoesNC,
        updateDatasPagamentoJuros: updateDatasPagamentoJurosNC,
        updateDatasIncorporacaoJuros: updateDatasIncorporacaoJurosNC,
        updateEmissorId: updateEmissorIdNC
      };
  }
};

export const applyDesminutadorData = (data: DesminutadorResponse, participantes: any[] = [], bancos: any[] = [], instrumentoTipo: InstrumentoFinanceiro) => {
  const dispatch = store.dispatch;

  try {
    if (!data) {
      throw new Error('Dados do desminutador inválidos ou vazios');
    }
    
    const actions = getInstrumentActions(instrumentoTipo);
    
    const caracteristicasData = mapToCaracteristicasState(data, participantes, bancos, dispatch, instrumentoTipo);
    const criteriosData = mapToCriteriosRemuneracaoState(data);
    const eventosData = mapToEventosFinanceirosState(data);
    
    if (!caracteristicasData || !criteriosData || !eventosData) {
      throw new Error('Falha ao mapear dados para o estado');
    }

    Object.entries(caracteristicasData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        dispatch(actions.updateCaracteristicasField({ name: key as any, value: value as any }));
      }
    });
    
    setTimeout(() => {
      if (caracteristicasData.cnpjEscriturador) {
        dispatch(actions.updateCaracteristicasField({ name: 'cnpjEscriturador', value: caracteristicasData.cnpjEscriturador }));
      }
      if (caracteristicasData.bancoLiquidanteEmissor) {
        dispatch(actions.updateCaracteristicasField({ name: 'bancoLiquidanteEmissor', value: caracteristicasData.bancoLiquidanteEmissor }));
      }
    }, 200);
    
    setTimeout(() => {
      if (caracteristicasData.cnpjEscriturador) {
        dispatch(actions.updateCaracteristicasField({ name: 'cnpjEscriturador', value: caracteristicasData.cnpjEscriturador }));
      }
      if (caracteristicasData.bancoLiquidanteEmissor) {
        dispatch(actions.updateCaracteristicasField({ name: 'bancoLiquidanteEmissor', value: caracteristicasData.bancoLiquidanteEmissor }));
      }
    }, 500);
    
    Object.entries(criteriosData).forEach(([key, value]) => {
      if (key !== 'remuneracao' && value !== undefined && value !== null) {
        dispatch(actions.updateCriteriosField({ name: key as any, value: value as any }));
      }
    });
    
    if (criteriosData.remuneracao) {
      Object.entries(criteriosData.remuneracao).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          dispatch(actions.updateRemuneracaoField({ name: key as any, value: value as any }));
        }
      });
    }
    
    if (criteriosData.custoEmissao) {
      Object.entries(criteriosData.custoEmissao).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          dispatch(actions.updateCustoEmissaoField({ name: key as any, value: value as any }));
        }
      });
    }
    
    if (eventosData.amortizacoes && eventosData.amortizacoes.length > 0) {
      dispatch(actions.updateAmortizacoes(eventosData.amortizacoes));
    }
    
    if (eventosData.datasPagamentoJuros && eventosData.datasPagamentoJuros.length > 0) {
      dispatch(actions.updateDatasPagamentoJuros(eventosData.datasPagamentoJuros));
    }
    
    if (eventosData.datasIncorporacaoJuros && eventosData.datasIncorporacaoJuros.length > 0) {
      dispatch(actions.updateDatasIncorporacaoJuros(eventosData.datasIncorporacaoJuros));
    }
    
    Object.entries(eventosData).forEach(([key, value]) => {
      if (key !== 'amortizacoes' && key !== 'datasPagamentoJuros' && key !== 'datasIncorporacaoJuros' && value !== undefined && value !== null) {
        dispatch(actions.updateEventosField({ name: key as any, value: value as any }));
      }
    });
    
    setTimeout(() => {
      dispatch(addAlert({
        severity: 'success',
        message: 'Formulários preenchidos com sucesso a partir do documento!'
      }));
    }, 100);
    
  } catch (error) {
    dispatch(addAlert({
      severity: 'error',
      message: 'Erro ao preencher formulários: ' + (error instanceof Error ? error.message : 'Erro desconhecido')
    }));
  }
};
